import '../pages/ConfirmAddress.css';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="terms-content">
      <h6>TERMS OF SERVICE</h6>
      <p className="last-updated">Last Updated: January 13, 2025</p>
      <p>
        These Terms of Service (&quot;<strong>Terms</strong>&quot;) apply to
        your access to and use of the websites (
        <a
          href="https://www.onbe.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>www.onbe.com</strong>
        </a>
        ,{' '}
        <a
          href="https://login.mypaymentvault.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>login.mypaymentvault.com</strong>
        </a>
        ,{' '}
        <a
          href="https://account.mypaymentvault.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>account.mypaymentvault.com</strong>
        </a>
        ,{' '}
        <a
          href="https://prepaiddigitalsolutions.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>prepaiddigitalsolutions.com</strong>
        </a>
        ,{' '}
        <a
          href="https://prepaidcardstatus.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>prepaidcardstatus.com</strong>
        </a>
        ,{' '}
        <a
          href="https://www.northlane.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>www.northlane.com</strong>
        </a>{' '}
        and any other site which may link back to these Terms, hereinafter
        referred to as the &quot;<strong>Sites</strong>&quot;), any applications
        (the &quot;<strong>App</strong>&quot; and together with the Site, the
        &quot;<strong>Platform</strong>&quot;), any Payment Program (the &quot;
        <strong>Program</strong>&quot;) and any features, content, products and
        other services offered by Onbe (collectively, the &quot;
        <strong>Services</strong>&quot;) provided by North Lane Technologies,
        Inc., an Onbe Company, (&quot;<strong>MyPaymentvault</strong>&quot; or
        &quot;<strong>we</strong>&quot;).
      </p>
      <p>
        Please read these terms carefully. By visiting our Platform and/or by
        using the Services, you agree to be bound fully and unconditionally by
        these Terms and Conditions of the Program Sponsor (the
        &quot;Sponsor&quot;), which is the entity that marketed and/or
        distributed a &quot;Payment&quot;, including a digital token, claimable
        payment, card number, security code, payment code, or reward code. The
        Terms and Sponsor&apos;s decisions are final and binding in all matters
        related to the Program. We reserve the right to update, change or
        replace any part of these Terms, including for any business reason or as
        may be required to comply with applicable laws, by posting updates
        and/or changes here. You are encouraged to review these Terms each time
        you use the Services because your use of the Services after the posting
        of changes will constitute your acceptance of the changes.{' '}
        <strong>
          If you do not agree to these Terms, including the mandatory
          arbitration provision and class action waiver in Section 13, do not
          access or use our Services.
        </strong>{' '}
        <br /> If you have any questions about these Terms or our Services,
        please contact us at: <br />
      </p>
      <table className="terms-table">
        <tbody>
          <tr>
            <td className="terms-table-cell">
              <p className="terms-table-text">Address:</p>
            </td>
            <td className="terms-table-cell-no-left">
              <p className="terms-table-text">
                North Lane Technologies, Inc., an Onbe Company.{' '}
              </p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <br />
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">P.O. Box 284</p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <br />
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">Conshohocken, PA 19428</p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <p className="terms-table-text">E-Mail Address:</p>
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">
                <a href="mailto:privacy@myPaymentvault.com">
                  privacy@myPaymentvault.com
                </a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Please refer to our Privacy Policy for information about how we collect,
        use and disclose information about you. <br />
        <a
          href="/data/xContent/recipient/op/program/privacy_cookies.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          privacy cookies
        </a>
      </p>
      <h6>1. Eligibility</h6>
      <p>
        You must be at least 18 years of age to access or use our Services. If
        you are accessing or using our Services on behalf of another person or
        entity, <br /> (a) you represent that you are authorized to accept these
        Terms on that person or entity&apos;s behalf, <br /> (b) that the person
        or entity agrees to be responsible to us if you or the other person or
        entity violates these Terms, and <br /> (c) references to
        &quot;you&quot; in these Terms will refer jointly to you and the other
        person or entity.
      </p>
      <h6>2. Timing</h6>
      <p>
        Timing varies by Program Sponsor. The Sponsor&apos;s computer is the
        official time keeping device for the Program. All Payments are subject
        to verification and validation by the Sponsor before any funds can be
        accessed. The Sponsor is not responsible for lost, late, expired,
        incomplete, invalid, unintelligible or misdirected registrations and/or
        redemptions, or for Payments that are deactivated or non-redeemable due
        to fraud, suspected fraud or non-compliance with Program rules and
        regulations. In the event of a dispute as to any registration or
        redemption, the Participant&apos;s Sponsor will make the final
        determination. All potential Payment recipients are subject to
        verification by the Sponsor, whose decisions are final and binding. A
        Participant will not receive a Payment or may be unable to use a
        Payment, even if the Program should so indicate, unless and until the
        Participant&apos;s eligibility has been verified. The Sponsor will not
        be held liable for a Participant&apos;s ineligibility or non-compliance
        with these Terms.
      </p>
      <h6>3. Payment Determination</h6>
      <p>
        All potential Payment recipients must comply with these Terms, and all
        Payments are contingent upon fulfilling all requirements. The
        Sponsor&apos;s decisions as to the administration and operation of the
        Program are final and binding in all matters related to the Program.
        Payments may not be sold or transferred and are not convertible to cash.
        The Sponsor reserves the right to substitute a Payment or Payment
        product option, in whole or in part, in the event that all or any
        component of a Payment or Payment product option is unavailable. Payment
        recipients are responsible for the reporting and payment of any
        applicable taxes and fees associated with Payment receipt and/or use.
        Payments are subject to verification of eligibility. If due to printing,
        production, technical or other errors, more value of a specified level
        is claimed than intended, the intended Payment value will be determined
        by the Sponsor according to the Program Rules.
      </p>
      <h6>4. User Accounts and Account Security</h6>
      <p>
        You may need to register for an account to access some or all of our
        Services. If you register for an account, you must provide accurate
        account information and promptly update this information if it changes.
        You also must maintain the security of your account and promptly notify
        us if you discover or suspect that someone has accessed your account
        without your permission. You are responsible for all activities that
        occur in connection with your account and accept all risks of
        unauthorized access.
      </p>
      <h6>5. Additional Terms</h6>
      <p>
        Additional terms may apply to specific features, products, or services
        associated with our Services (“<strong>Additional Terms</strong>”),
        including without limitation a cardholder bank agreement that you may
        have with a sponsor bank and a customer program agreement that you may
        have with Mypaymentvault. These Terms are not intended to cover subject
        matter addressed in such Additional Terms, and to the extent any
        Additional Terms conflict with these Terms, the Additional Terms govern
        with respect to your access to or use of the applicable feature,
        product, or service.
      </p>
      <h6>6. Prohibited Conduct and Content</h6>
      <p>
        You will not violate any applicable law, contract, intellectual property
        or other third-party right or commit a tort, and you are solely
        responsible for your conduct while accessing or using our Services.{' '}
        <br /> You will not:
      </p>{' '}
      <ul>
        <li>
          Engage in any harassing, threatening, intimidating, predatory or
          stalking conduct;
        </li>
        <li>
          Use or attempt to use another user&apos;s account without
          authorization from that user and Mypaymentvault;
        </li>
        <li>
          Use our Services in any manner that could interfere with, disrupt,
          negatively affect or inhibit other users from fully enjoying our
          Services or that could damage, disable, overburden or impair the
          functioning of our Services in any manner;
        </li>
        <li>
          Reverse engineer any aspect of our Services (except to the extent such
          prohibition is not permitted under applicable law) or do anything that
          might discover source code or bypass or circumvent measures employed
          to prevent or limit access to any part of our Services;
        </li>{' '}
        <li>
          {' '}
          Attempt to circumvent any content-filtering techniques we employ or
          attempt to access any feature or area of our Services that you are not
          authorized to access;{' '}
        </li>{' '}
        <li>
          {' '}
          Develop or use any third-party applications that interact with our
          Services without our prior written consent, including any scripts
          designed to scrape or extract data from our Services;{' '}
        </li>{' '}
        <li>
          {' '}
          Bypass or ignore instructions contained in our robots.txt file that
          controls automated access to portions of our Services; or Use our
          Services for any illegal or unauthorized purpose, or engage in,
          encourage or promote any activity that violates these Terms.
        </li>
      </ul>
      <h6>7. Limited License; Copyright and Trademark</h6>
      <p>
        Our Services and the text, graphics, images, photographs, videos,
        illustrations, trademarks, trade names, service marks, logos, slogans
        and other content contained therein (collectively, the “
        <strong>MyPaymentvault Content</strong>”) are owned by or licensed to
        MyPaymentvault and are protected under both United States and foreign
        laws. Except as explicitly stated in these Terms, MyPaymentvault and our
        licensors reserve all rights in and to our Services and the
        MyPaymentvault Content. We hereby grant you a limited, nonexclusive,
        nontransferable, non-sublicensable, revocable license to access and use
        our Services and MyPaymentvault Content for your internal business
        purposes; however, such license is subject to these Terms and does not
        include any right to <br /> (a) sell, resell or commercially use our
        Services or MyPaymentvault Content; <br /> (b) copy, reproduce,
        distribute, publicly perform or publicly display MyPaymentvault Content,
        except as expressly permitted by us or our licensors; <br /> (c) modify
        the MyPaymentvault Content, remove any proprietary rights notices or
        markings, or otherwise make any derivative uses of our Services or
        MyPaymentvault Content; <br /> (d) use any data mining, robots or
        similar data gathering or extraction methods; and <br /> (e) use our
        Services or MyPaymentvault Content other than for their intended
        purposes. Any use of our Services or MyPaymentvault Content other than
        as specifically authorized herein, without our prior written permission,
        is strictly prohibited and will terminate the license granted herein.
      </p>
      <h6>8. Feedback</h6>
      <p>
        Any questions, comments, suggestions, ideas, original or creative
        materials or other information you submit about Mypaymentvault or our
        products or Services (collectively, &quot;<strong>Feedback</strong>
        &quot;), is non-confidential and will become the sole property of
        Mypaymentvault. We will own exclusive rights, including, without
        limitation, all intellectual property rights, in and to Feedback and
        will be entitled to the unrestricted use and dissemination of Feedback
        for any purpose, commercial or otherwise, without acknowledgment or
        compensation to you.
      </p>
      <h6>9. Copyright Complaints</h6>
      <p>
        We have a policy of limiting access to our Services and terminating the
        accounts of users who infringe the intellectual property rights of
        others. If you believe that anything on our Services infringes any
        copyright that you own or control, you may notify Onbe&apos;s Designated
        Agent as follows:
      </p>
      <table className="terms-table">
        <tbody>
          <tr>
            <td className="terms-table-cell">
              <p className="terms-table-text">Designated Agent:</p>
            </td>
            <td className="terms-table-cell-no-left">
              <p className="terms-table-text">Director of Compliance</p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <p className="terms-table-text">Address:</p>
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">
                North Lane Technologies, Inc., an Onbe Company.{' '}
              </p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <br />
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">P.O. Box 284</p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <br />
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">Conshohocken, PA 19428</p>
            </td>
          </tr>
          <tr>
            <td className="terms-table-cell-no-top">
              <p className="terms-table-text">E-Mail Address:</p>
            </td>
            <td className="terms-table-cell-inner">
              <p className="terms-table-text">
                <a href="mailto:privacy@mypaymentvault.com">
                  privacy@mypaymentvault.com
                </a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Please see{' '}
        <a
          href="https://www.copyright.gov/title17/92chap5.html#512"
          target="_blank"
          rel="noopener noreferrer"
        >
          17 U.S.C. §512(c)(3)
        </a>{' '}
        for the requirements of a proper notification. Also, please note that if
        you knowingly misrepresent that any activity or material on our Services
        is infringing, you may be liable to Onbe for certain costs and damages.
      </p>
      <h6>10. Indemnification</h6>
      <p>
        To the fullest extent permitted by applicable law, you will indemnify,
        defend, and hold harmless Mypaymentvault, our subsidiaries and
        affiliates, and each of our respective officers, directors, agents,
        partners and employees (individually and collectively, the &quot;
        <strong>Mypaymentvault Parties</strong>&quot;) from and against any
        loss, liability, claim, demand, damages, expenses or costs (&quot;
        <strong>Claims</strong>&quot;) arising out of or related to (a) your
        access to or use of our Services; (b) your User Content or Feedback; (c)
        your violation of these Terms; (d) your violation, misappropriation or
        infringement of any rights of another (including intellectual property
        rights or privacy rights); or (e) your conduct in connection with our
        Services. You agree to promptly notify Mypaymentvault of any third party
        Claims, cooperate with Mypaymentvault Parties in defending such Claims
        and pay all fees, costs and expenses associated with defending such
        Claims (including, but not limited to, attorneys&apos; fees). You also
        agree that North Lane will have control of the defense or settlement of
        any third party Claims. This indemnity is in addition to, and not in
        lieu of, any other indemnities set forth in a written agreement between
        you and Mypaymentvault or the other Mypaymentvault Parties.
      </p>
      <h6>11. Disclaimers</h6>
      <p>
        <strong>
          (a) We do not control, endorse or take responsibility for any User
          Content or third-party content available on or linked to by our
          Services.
        </strong>
      </p>
      <p>
        <strong>
          (b) Your use of our Services is at your sole risk. Our Services are
          provided &quot;as is&quot; and &quot;as available&quot; without
          warranties of any kind, either express or implied, including, but not
          limited to, implied warranties of merchantability, fitness for a
          particular purpose, title, and non-infringement. In addition,
          Mypaymentvault does not represent or warrant that our Services are
          accurate, complete, reliable, current or error-free. While
          Mypaymentvault attempts to make your access to and use of our Services
          safe, we cannot and do not represent or warrant that our Services or
          servers are free of viruses or other harmful components. You assume
          the entire risk as to the quality and performance of the Services.
        </strong>
      </p>
      <h6>12. Limitation of Liability</h6>
      <p>
        <strong>
          (a) Mypaymentvault and the other Mypaymentvault Parties will not be
          liable to you under any theory of liability—whether based in contract,
          tort, negligence, strict liability, warranty, or otherwise—for any
          indirect, consequential, exemplary, incidental, punitive or special
          damages or lost profits, even if Mypaymentvault or the other
          Mypaymentvault Parties have been advised of the possibility of such
          damages.
        </strong>
      </p>
      <p>
        <strong>
          (b) The total liability of Mypaymentvault and the other Mypaymentvault
          Parties, for any claim arising out of or relating to these Terms or
          our Services, regardless of the form of the action, is limited to the
          amount paid, if any, by you to access or use our Services.
        </strong>
      </p>
      <p>
        <strong>
          (c) The limitations set forth in this section will not limit or
          exclude liability for the gross negligence, fraud or intentional
          misconduct of Mypaymentvault or the other Mypaymentvault Parties or
          for any other matters in which liability cannot be excluded or limited
          under applicable law. Additionally, some jurisdictions do not allow
          the exclusion or limitation of incidental or consequential damages, so
          the above limitations or exclusions may not apply to you.
        </strong>
      </p>
      <h6>13. Release</h6>
      <p>
        To the fullest extent permitted by applicable law, you release
        Mypaymentvault and the other Mypaymentvault Parties from responsibility,
        liability, claims, demands, and/or damages (actual and consequential) of
        every kind and nature, known and unknown (including, but not limited to,
        claims of negligence), arising out of or related to disputes between
        users and the acts or omissions of third parties.{' '}
        <strong>
          {' '}
          You expressly waive any rights you may have under California Civil
          Code § 1542 as well as any other statute or common law principles that
          would otherwise limit the coverage of this release to include only
          those claims which you may know or suspect to exist in your favor at
          the time of agreeing to this release.
        </strong>
      </p>
      <h6>14. Dispute Resolution; Binding Arbitration</h6>
      <p>
        <strong>
          (a) Please read the following section carefully because it requires
          you to arbitrate certain disputes and claims with Mypaymentvault and
          limits the manner in which you can seek relief from us.
        </strong>
      </p>
      <p>
        (b) Except for small claims disputes in which you or Mypaymentvault seek
        to bring an individual action in small claims court located in the
        county of your billing address or disputes in which you or
        Mypaymentvault seeks injunctive or other equitable relief for the
        alleged unlawful use of intellectual property, you and Mypaymentvault
        waive your rights to a jury trial and to have any dispute arising out of
        or related to these Terms or our Services resolved in court. Instead,
        all disputes arising out of or relating to these Terms or our Services
        will be resolved through confidential binding arbitration held in
        Manhattan, New York, New York in accordance with the Streamlined
        Arbitration Rules and Procedures (&quot;<strong>Rules</strong>&quot;) of
        the Judicial Arbitration and Mediation Services (&quot;
        <strong>JAMS</strong>&quot;), which are available on the{' '}
        <a
          href="https://www.jamsadr.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          JAMS website&nbsp;and hereby incorporated by reference.
        </a>
        . You either acknowledge and agree that you have read and understand the
        rules of JAMS or waive your opportunity to read the rules of JAMS and
        any claim that the rules of JAMS are unfair or should not apply for any
        reason.
      </p>
      <p>
        <strong>
          (c) You and Mypaymentvault agree that any dispute arising out of or
          related to these Terms or our Services is personal to you and
          Mypaymentvault and that any dispute will be resolved solely through
          individual arbitration and will not be brought as a class arbitration,
          class action or any other type of representative proceeding.
        </strong>
      </p>
      <p>
        (d) You and Mypaymentvault agree that these Terms affect interstate
        commerce and that the enforceability of this Section 12 will be
        substantively and procedurally governed by the Federal Arbitration Act,
        9 U.S.C. § 1, et seq. (the &quot;FAA&quot;), to the maximum extent
        permitted by applicable law. As limited by the FAA, these Terms and the
        JAMS Rules, the arbitrator will have exclusive authority to make all
        procedural and substantive decisions regarding any dispute and to grant
        any remedy that would otherwise be available in court; provided,
        however, that the arbitrator does not have the authority to conduct a
        class arbitration or a representative action, which is prohibited by
        these Terms. The arbitrator may only conduct an individual arbitration
        and may not consolidate more than one individual&apos;s claims, preside
        over any type of class or representative proceeding or preside over any
        proceeding involving more than one individual. You and Mypaymentvault
        agree that for any arbitration you initiate, you will pay the filing fee
        and Mypaymentvault will pay the remaining JAMS fees and costs. For any
        arbitration initiated by Mypaymentvault, Mypaymentvault will pay all
        JAMS fees and costs. You and Mypaymentvault agree that the state or
        federal courts of the State of New York and the United States sitting in
        Manhattan, New York have exclusive jurisdiction over any appeals and the
        enforcement of an arbitration award.
      </p>
      <p>
        (e) Any claim arising out of or related to these Terms or our Services
        must be filed within one year after such claim arose; otherwise, the
        claim is permanently barred, which means that you and Mypaymentvault
        will not have the right to assert the claim.
      </p>
      <h6>15. Governing Law and Venue</h6>
      <p>
        These Terms and your access to and use of our Services will be governed
        by and construed and enforced in accordance with the laws of Delaware,
        without regard to conflict of law rules or principles (whether of
        Delaware or any other jurisdiction) that would cause the application of
        the laws of any other jurisdiction. Any dispute between the parties that
        is not subject to arbitration or cannot be heard in small claims court
        will be resolved in the state or federal courts of Delaware and the
        United States, respectively, sitting in Wilmington, DE.
      </p>
      <h6>16. Changes to these Terms</h6>
      <p>
        We may make changes to these Terms from time to time by providing notice
        to you. We will provide notice to you by posting the amended Terms to
        our Services and updating the &quot;Last Updated&quot; date above. We
        may also provide additional notice, such as by sending an email
        notification to the email address associated with your account or
        providing supplemental notice through our Services. Unless we say
        otherwise in our notice, the amended Terms will be effective immediately
        upon posting to our Services, and your continued access to and use of
        our Services after we provide notice will confirm your acceptance of the
        changes. If you do not agree to the amended Terms, you must stop
        accessing and using our Services.
      </p>
      <h6>17. Termination</h6>
      <p>
        We reserve the right, without notice and in our sole discretion, to
        terminate your right to access or use our Services. We are not
        responsible for any loss or harm related to your inability to access or
        use our Services.
      </p>
      <h6>18. Severability</h6>
      <p>
        If any provision or part of a provision of these Terms is unlawful, void
        or unenforceable, that provision or part of the provision is deemed
        severable from these Terms and does not affect the validity and
        enforceability of any remaining provisions.
      </p>
      <h6>19. Miscellaneous</h6>
      <p>
        In no event will Mypaymentvault or the Mypaymentvault Parties be
        responsible for any delay or failure to perform due to an event or
        circumstances outside the reasonable control of Mypaymentvault. These
        Terms constitute the entire agreement between you and Mypaymentvault
        relating to your access to and use of our Services. The failure of
        Mypaymentvault to exercise or enforce any right or provision of these
        Terms will not operate as a waiver of such right or provision. The
        section titles in these Terms are for convenience only and have no legal
        or contractual effect. Except as otherwise provided herein, these Terms
        are intended solely for the benefit of the parties and are not intended
        to confer third party beneficiary rights upon any other person or
        entity.
      </p>
      <h6>Electronic Communications Agreement</h6>
      <strong>Agreement to Receive Electronic Communications</strong>
      <p>
        This Electronic Communications Agreement (&quot;Disclosure&quot;)
        applies to all communications related to any applications (the &quot;
        <strong>App</strong>&quot; and together with the Site, the &quot;
        <strong>Platform</strong>&quot;), any Payment Program (the &quot;
        <strong>Program</strong>&quot;) and any features, content, products and
        other services offered by Onbe (collectively, the &quot;Services&quot;)
        available through account.mypaymentvault.com (the &quot;Website&quot;).
        This Disclosure supplements and is to be construed in accordance with
        the Terms of Access you received when you agreed to use one of
        Onbe&apos;s websites ({' '}
        <a href="https://www.onbe.com/" target="_blank" rel="noreferrer">
          <strong> www.onbe.com</strong>
        </a>
        ,{' '}
        <a
          href="https://login.mypaymentvault.com/"
          target="_blank"
          rel="noreferrer"
        >
          <strong> login.mypaymentvault.com</strong>
        </a>
        ,{' '}
        <a
          href="https://account.mypaymentvault.com/"
          target="_blank"
          rel="noreferrer"
        >
          <strong> account.mypaymentvault.com</strong>
        </a>
        ,{' '}
        <a
          href="https://prepaiddigitalsolutions.com/"
          target="_blank"
          rel="noreferrer"
        >
          <strong> prepaiddigitalsolutions.com</strong>
        </a>
        ,{' '}
        <a
          href="https://prepaidcardstatus.com/"
          target="_blank"
          rel="noreferrer"
        >
          <strong> prepaidcardstatus.com</strong>
        </a>
        ,{' '}
        <a href="https://www.northlane.com/" target="_blank" rel="noreferrer">
          <strong> www.northlane.com</strong>
        </a>{' '}
        and any other site which may link back to this Disclosure, hereinafter
        referred to as the &quot;<strong>Sites</strong>&quot;).
      </p>
      <p>
        &quot;We,&quot; &quot;us,&quot; and &quot;our&quot; refer to Program
        Manager. &quot;Issuer&quot; means the issuing entity. &quot;You&quot;
        and &quot;your&quot; refers to the person(s) to whom our Services were
        offered. &quot;Communication(s)&quot; means any customer agreement or
        amendments thereto; disclosure; notice; response to claims; transaction
        history; privacy policy; and all other information related to our
        Services, including but not limited to information that we are required
        by law to provide you in writing.
      </p>
      <p>
        Our Services are intended for use only by person(s) who are willing and
        able to receive notices and communications exclusively through our
        Sites, or via electronic mail (&quot;E-mail&quot;). If you do not agree
        to receive the legally required notices and communications described
        herein in electronic and not paper form, then you may not use our
        Services. Similarly, if after providing consent hereunder, you withdraw
        it, we reserve the right to terminate your use of our Services.
      </p>
      <p>
        <strong>
          Scope of Communications to Be Provided in Electronic Form.
        </strong>{' '}
        When you use our Services to which this Disclosure applies, you agree
        that any Communications will be provided in electronic format, to the
        extent allowed by law, and that paper Communications will not be sent.
        Your consent to receive electronic Communications and transactions
        includes, but is not limited to:
      </p>
      <ul>
        <li>
          All legal and regulatory disclosures and communications associated
          with the our Services;
        </li>
        <li>
          Consumer Agreements related to our Services, Terms and Conditions, and
          any notices about changes in Terms and Conditions;
        </li>
        <li>Privacy policies and notices;</li>
        <li>Responses to claims filed in connection with our Services;</li>
        <li>Notices regarding insufficient funds or negative balances; and</li>
        <li>
          All other communications concerning our Services and any related
          transactions, products, or services.
        </li>
      </ul>
      <p>
        <strong>Method of Providing Communications in Electronic Form.</strong>{' '}
        All communications that we provide in electronic form will be provided
        either (1) by E-mail or (2) by access to the Website.
      </p>
      <p>
        <strong>How to Withdraw Consent.</strong> You may withdraw your consent
        to receive Communications in electronic form by calling us at
        866-326-8689. At our option, we may treat your provision of an invalid
        e-mail address, or the subsequent malfunction of a previously valid
        e-mail address, as a withdrawal of your consent to receive electronic
        Communications. Any withdrawal of your consent to receive electronic
        Communications will be effective only after we have a reasonable period
        of time to process your withdrawal.
      </p>
      <p>
        <strong>How to Update Records.</strong> It is your responsibility to
        provide us with true, accurate and complete e-mail address, contact, and
        other information related to the Disclosure and your Card, and to
        maintain and update promptly any changes in this information. You can
        update information (such as your e-mail address) through our web site or
        by calling us at 866-326-8689.
      </p>
      <p>
        <strong>System Requirements.</strong> In order to access, view, and
        retain electronic Communications that we make available, you must have:
      </p>
      <ul>
        <li>
          An Internet browser that supports 128-bit encryption, which requires
          Windows 2000 or later version running either Microsoft Edge or
          Firefox, or Mac OSX 10.2 or higher running Safari web browser. Your
          access to this page verifies that your browser and encryption
          software/device meets these requirements;
        </li>
        <li>
          Sufficient electronic storage capacity on your computer&apos;s hard
          drive or other data storage unit;
        </li>
        <li>
          An active E-mail account with an Internet service provider and e-mail
          software;
        </li>
        <li>
          A personal computer, tablet, or cell phone with the ability to read
          text-formatted email or by accessing our web site using one of the
          browsers specified above;
        </li>
        <li>Adobe Reader version 9.0 or higher</li>
      </ul>
      <p>
        We may update these requirements as necessary to preserve the ability to
        receive electronic Communications. If there is a substantial change in
        these requirements, you will be notified of the changes accordingly.
      </p>
      <p>
        <strong>Requesting Paper Copies.</strong> We will not send paper copies
        of any Communication, however, we reserve the right, but assume no
        obligation, to provide a paper (instead of electronic) copy of any
        Communication that you have authorized us to provide electronically. You
        can obtain a paper copy of an electronic Communication by printing it or
        by requesting that we mail a paper copy. To request a paper copy, call
        us at 866-326-8689. We may charge you a reasonable service charge, of
        which we have provided you prior notice, for the delivery of paper
        copies of any Communication provided to you electronically pursuant to
        this authorization. We will not charge you to deliver a paper copy of
        your transaction history provided that you make no more than one request
        per month and the request does not exceed 24 months of transactions.
      </p>
      <p>
        <strong>Communications in Writing.</strong> All Communications in either
        electronic or paper format from us to you will be considered &quot;in
        writing.&quot; You should print or download a copy of this Disclosure
        and any other Communications.
      </p>
      <p>
        <strong>Federal Law.</strong> You acknowledge and agree that consent to
        electronic Communications is being provided in connection with a
        transaction affecting interstate commerce that is subject to the federal
        Electronic Signatures in Global and National Commerce Act (the
        &quot;Act&quot;), and that you and we both intend that the Act applies
        to the fullest extent possible to validate our mutual ability to conduct
        business by electronic means.
      </p>
      <p>
        <strong>Termination/Changes.</strong> We reserve the right, at our sole
        discretion, to discontinue the provision of electronic Communications,
        or to terminate or change the terms and conditions upon which electronic
        Communications are provided. We will provide you with notice of any such
        termination or change as required by law.
      </p>
      <p>
        <strong>Consent.</strong> By clicking &quot;I agree,&quot; By clicking a
        box indicating that you agree, this constitutes your electronic
        signature, and you give us your affirmative consent to receive
        electronic Communications as described herein. You further agree that
        your computer satisfies the hardware and software requirements specified
        above and that you have provided us with your current E-mail address to
        which we may send you electronic Communications.
      </p>
      <h6>Website Privacy Policy</h6>
      <h6>PURPOSE</h6>
      <p>
        Our mission is to manage and modernize consumer and workforce
        disbursements, enabling program sponsors (&quot;clients&quot;) to
        outsource their entire business to individual (B2I) payment operations –
        relieving them of the cost, complexity and risk that come with
        orchestrating these payments in-house, and delivering a customer
        experience that is instant, convenient and simple. In order to do this,
        we collect, use, and share some of your personal information.
      </p>
      <p>
        When we do so, we process personal information solely to provide
        services to clients and card or payment issuers; we collect, use and
        disclose the data only under the instructions of the client or the card
        or payment issuer; and our processing of the data is subject to their
        instructions and privacy notices. Please read the agreement and terms
        and conditions provided in conjunction with your payment for further
        details regarding your payment issuer. For access to each payment
        issuer&apos;s privacy notice, please click on each name:
      </p>
      <ul className="terms-list" type="disc">
        <li className="terms-list-item">
          <a
            href="https://ebixcash.com/privacy/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">Ebixcash</span>
            </strong>
          </a>
        </li>
        <li className="terms-list-item">
          <a
            href="https://login.mypaymentvault.com/data/xContent/recipient/op/program/privacy_mb_en_US.html"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">
                Fifth Third Bank, National Association
              </span>
            </strong>
          </a>
          <span className="terms-link-text">, Member FDIC</span>
        </li>

        <li className="terms-list-item">
          <a
            href="https://www.hdfcbank.com/personal/useful-links/privacy"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">HDFC Bank</span>
            </strong>
          </a>
        </li>

        <li className="terms-list-item">
          <a
            href="https://www.pathward.com/content/dam/pathward/us/en/documents/pdfs/Privacy-Policy-Notice.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">
                Pathward, National Association
              </span>
            </strong>
          </a>
          <span className="terms-link-text">, Member FDIC</span>
        </li>

        <li className="terms-list-item">
          <a
            href="https://www.peoplestrust.com/en/legal/privacy-security/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">
                {"People's Trust Company"}
              </span>
            </strong>
          </a>
        </li>

        <li className="terms-list-item">
          <a
            href="https://highimpactpayments.com/privacy/Sunrise_Privacy_Policy.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">Sunrise Banks</span>
            </strong>
          </a>
          <span className="terms-link-text">, Member FDIC</span>
        </li>

        <li className="terms-list-item">
          <a
            href="https://thebancorp.mybankingservices.com/Global/docs/privacy/Retailnotice_generic.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">The Bancorp Bank N.A.,</span>
            </strong>
          </a>
          <span className="terms-link-text">&nbsp;Member FDIC</span>
        </li>

        <li className="terms-list-item">
          <a
            href="https://www.transactpaymentsltd.com/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>
              <span className="terms-link-text">Transact Payments Limited</span>
            </strong>
          </a>
        </li>
      </ul>
      <p>
        The purpose of this Privacy Notice is to share how we do this and how to
        exercise your data protection rights.
      </p>
      <h6>Topics</h6>
      <ul>
        <li>What data do we collect?</li>
        <li>Children</li>
        <li>How do we collect your data?</li>
        <li>How will we use your data?</li>
        <li>How do we store your data?</li>
        <li>What and with whom we share</li>
        <li>How to control your privacy options</li>
        <li>What are your rights under data privacy laws?</li>
        <li>What are cookies?</li>
        <li>How do we use cookies?</li>
        <li>What types of cookies do we use?</li>
        <li>How to manage your cookies</li>
        <li>Privacy policies of other websites</li>
        <li>Changes to our privacy policy</li>
        <li>How to contact us</li>
        <li>How to contact the appropriate authorities</li>
      </ul>
      <p>
        This Privacy Notice describes how we manage the personal information we
        collect about users of our Web sites and mobile applications, as well as
        the personal information we collect in providing our products and
        services or when individuals communicate with us about our Web sites,
        mobile apps, products or services.
      </p>
      <h6>WHAT DATA DO WE COLLECT?</h6>
      <p>We may collect the following data, as applicable:</p>
      <ul>
        <li>
          Full name, personal or business contact information including physical
          mailing address, email address, telephone number, and in some
          instances date of birth and/or national identification number (e.g.,
          SSN).
        </li>
        <li>
          Contact preferences and other business information that helps us do
          business with you.
        </li>
        <li>
          Technical information such as login information, IP address, device
          and operating system.
        </li>
        <li>
          Other data with your consent or as allowed or required by applicable
          law.
        </li>
      </ul>
      <h6>CHILDREN</h6>
      <p>
        Our Services are meant for adults and are not for children. We do not
        intentionally collect personal information from children under 13
        without authorization from a parent or legal guardian. If you think your
        child under 13 has sent us data, you can contact us at{' '}
        <a href="mailto:privacy@mypaymentvault.com">
          <strong>
            <span className="terms-link-text">privacy@mypaymentvault.com</span>
          </strong>
        </a>
        .
      </p>
      <h6>HOW DO WE COLLECT YOUR DATA?</h6>
      <p>
        You directly provide us with most of the data we collect. We collect
        data and process data when you:
      </p>
      <ul>
        <li>Use or view our website via your browser&apos;s cookies.</li>
        <li>Use our products or services.</li>
        <li>Contact customer service.</li>
      </ul>
      <p>
        In addition to these items, we also process personal information on
        behalf of our clients and card or payment issuers. When we do so, we
        process personal information solely to provide services to our clients
        and card or payment issuers. We collect, use and disclose the data only
        under the instructions of our client or the card or payment issuer, and
        our processing of the data is subject to their instructions and Privacy
        Notices.
      </p>
      <h6>HOW WILL WE USE YOUR DATA?</h6>
      <p>
        We process your personal information, on specific legal grounds. We do
        so with your consent, to fulfill the contractual requirements we have
        with you, comply with our legal responsibilities, or as needed to
        deliver our services and products and for other legitimate business
        interests for the purposes described in this Privacy Notice.
      </p>
      <p>
        We collect your data so that we can operate and support our services and
        products only. We may use your data to:
      </p>
      <ul>
        <li>
          Send administrative material to you, such as changes to our terms,
          conditions, and policies.
        </li>
        <li>Provide access to our website and customer service.</li>
        <li>Provide technical support.</li>
        <li>Send you alerts that you requested.</li>
        <li>Identify areas where our products and services can be enhanced.</li>
        <li>
          Detect and protect against errors, fraud, or other criminal activity.
        </li>
      </ul>
      <p>
        We may also use your personal information in other instances with your
        consent, and as required by law.
      </p>
      <h6>HOW DO WE STORE YOUR DATA?</h6>
      <p>
        We store personal information in the United States (&quot;U.S.&quot;).
        If you reside outside of the U.S., you understand that we transfer
        personal information to the U.S. Our products and services and
        associated practices comply with privacy provisions as set forth by the
        U.S. government, including the U.S. Department of Commerce&apos;s EU
        Privacy Shield Framework, and GDPR as required by EU/UK. When we
        transfer your personal information to service providers or third parties
        as outlined in this Privacy Notice, we rely on contractual clauses to
        administer the transfer of that personal information and uphold those
        entities to protecting the data as described in this Privacy Notice or
        as required by law.
      </p>
      <p>
        We implement security policies, processes and technical security
        solutions to protect personal information which includes various network
        safeguards, logging and alerting. In order to perform certain
        obligations, our authorized employees and service providers will need
        access to your personal information. We contractually require our
        service providers to protect your personal information.
      </p>
      <p>
        We may hold personal information as long as required or relevant for the
        practices described in this Privacy Notice or as otherwise applicable by
        law. Actual hold periods differ depending on the type of services and
        products. The principles we use to determine the holding periods include
        the following:
      </p>
      <ul>
        <li>
          Personal information required to provide our services and products as
          described in this Privacy Notice;
        </li>
        <li>Personal information required for auditing purposes;</li>
        <li>
          Personal information required to troubleshoot problems or to assist
          with investigations;
        </li>
        <li>Personal information required to enforce our policies; and</li>
        <li>
          Personal information required to comply with legal requirements.
        </li>
      </ul>
      <p>
        Regulations require financial institutions to obtain, verify, and record
        information that identifies each person for whom we open or have
        established an account. With respect to such records, we generally hold
        those records for a minimum of seven (7) years or such other time period
        as may be required pursuant to applicable law.
      </p>
      <h6>WHAT AND WITH WHOM WE SHARE</h6>
      <p>
        We do not share your personal information with third parties for joint
        marketing purposes or so they can market to you, without your prior
        express consent. We may share your personal information:
      </p>
      <ul>
        <li>
          With organizations and partners that help us operate our business by
          providing services such as website hosting, data analysis, information
          technology, customer service, email delivery, auditing and other
          similar services.
        </li>
        <li>
          With partners and other vendors that perform services on our behalf,
          such as network services support, including data processing services,
          customer service, call center services, information technology
          services, internal audit, management, or administrative purposes.
        </li>
        <li>
          To comply with the law or other legal responsibilities such as
          responding to subpoenas, including laws and other legal duties outside
          your country of residence.
        </li>
        <li>
          To answer requests from government authorities including authorities
          outside your country of residence.
        </li>
        <li>
          To protect our rights, business operations and possessions, or that of
          our users, employees and partners.
        </li>
        <li>
          To investigate, stop, or take action concerning possible or suspected
          illegal activities, fraud, or violations of our terms and conditions.
        </li>
      </ul>
      <h6>IDENTITY VERIFICATION & ANTI-MONEY LAUNDERING</h6>
      <p>
        Identity verification or an anti-money laundering check may need to be
        performed by a third party for the purpose of potentially supporting a
        relationship involving a financial transaction.
      </p>
      <p>
        The relevant credit reference agency is TransUnion International UK
        Limited.
      </p>
      <p>
        The search footprint retained by TransUnion International UK Limited
        related to the verification will indicate that either an anti-money
        laundering check or an identity check has been performed.
      </p>
      <p>
        The search footprint retained by the credit reference agency will read
        as having been made by Trulioo Information Services Inc.
      </p>
      <h6>HOW TO CONTROL YOUR PRIVACY OPTIONS</h6>
      <p>
        You can update your account profile online or by email. We maintain
        electronic records of your personal information for the purposes
        described in this Privacy Notice. You will be able to access and edit
        your personal information on the website listed on the back of the card.
        Otherwise, you may contact us at the email address listed at the bottom
        of this Privacy Notice. Your right to access, correct or delete your
        personal information indicated in our records is subject to applicable
        law including our right to retain documentation of our compliance with
        applicable legal requirements and technology limitations. We may take
        reasonable steps to confirm your identity before giving access or making
        modifications to your personal information.
      </p>
      <p>
        If we receive data from other sources, we may direct you to contact
        those sources. Please note that we are not responsible for permitting
        you to review, or for updating or deleting personal information that you
        provide to those sources or any other third party.
      </p>
      <h6>WHAT ARE YOUR RIGHTS UNDER DATA PRIVACY LAWS?</h6>
      <p>
        When you provide us with your personal information it is only used for
        the purposes of providing products and services as described in this
        Privacy Notice. You have the option to opt-out of certain uses and
        disclosures of your personal information as outlined in this Privacy
        Notice. We may not be able to provide the full extent of our products
        and services if you do opt out. If you would like to opt out of these
        uses or disclosures of your personal information, you may contact us at
        the email address listed at the bottom of this Privacy Notice.
      </p>
      <p>
        <strong>California Residents</strong>
      </p>
      <p>
        If you are a California resident, California law may provide you with
        additional rights regarding our use of your personal information.
        Effective January 1, 2020, under the California Consumer Privacy Act
        (CCPA), residents of California have certain rights to access, delete,
        or otherwise control the use, collection, and/or disclosure of their
        information. California residents may also opt out of the sale of such
        information, if applicable; please note that we do not sell your
        personal information. These provisions of the CCPA do not apply to
        personal information collected, processed, shared, or disclosed by
        financial institutions pursuant to federal law.
      </p>
      <p>
        To exercise your rights as described above, please submit a request via
        our{' '}
        <a
          href="https://onbe-privacy.my.onetrust.com/webform/2210d5ab-d423-4178-86dc-9c670f54317f/56dd8c4c-d316-465e-a658-d73d12fb73ca"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">privacy webform</span>
          </strong>
        </a>
        .
      </p>
      <p>
        Only you or a person registered with the California Secretary of State
        that you authorize to act on your behalf, may make a verifiable consumer
        request related to your personal information. You may also make a
        verifiable consumer request on behalf of your minor child.
      </p>
      <p>
        You may only make a verifiable consumer request for access or data
        portability twice within a 12-month period. The verifiable consumer
        request must:
      </p>
      <ul>
        <li>
          Provide sufficient information that allows us to reasonably verify you
          are the person about whom we collected personal information or an
          authorized representative.
        </li>
        <li>
          Describe your request with sufficient detail that allows us to
          properly understand, evaluate, and respond to it.
        </li>
      </ul>
      <p>
        Please note, consumers will not be subject to discriminatory treatment
        for the exercise of the privacy rights conferred by the CCPA.
      </p>
      <p>
        <strong>EU & UK Residents</strong>
      </p>
      <p>
        We adhere to applicable data protection laws in the EU and UK, when
        relevant and appropriate, including the General Data Protection
        Regulation (&quot;GDPR&quot;).
      </p>
      <p>
        We would like to make sure you are fully aware of all your data
        protection rights. Every user is entitled to the following:
      </p>
      <ul>
        <li>
          The right to access – You have the right to request from us copies of
          your personal information.
        </li>
        <li>
          The right to rectification – You have the right to request that we
          correct any information you believe is inaccurate. You also have the
          right to request we complete the information you believe is
          incomplete.
        </li>
        <li>
          The right to erasure - You have the right to request that we erase
          your personal information, under certain conditions.
        </li>
        <li>
          The right to restrict processing - You have the right to request that
          we restrict the processing of your personal information under certain
          conditions.
        </li>
        <li>
          The right to object to processing - You have the right to object to us
          processing your personal information, under certain conditions.
        </li>
        <li>
          The right to data portability - You have the right to request that we
          transfer the data that we have collected to another organization, or
          directly to you, under certain conditions.
        </li>
      </ul>
      <p>
        We will make every effort to honor your request, however in some
        situations, we may not be able to act and/or may impose limitations on
        your request. For instance, if your request is likely to adversely
        affect the rights and freedoms of others, prejudice the execution or
        enforcement of the law, interfere with pending or future litigation, or
        infringe on applicable law.
      </p>
      <p>
        You may exercise these rights free of charge. However, we may charge a
        reasonable fee or refuse to act on a request if it is manifestly
        unfounded or excessive, in particular because of its repetitive
        character.
      </p>
      <p>
        If you make a request, we have one month to respond to you. If you would
        like to exercise any of these rights, please submit a request via our{' '}
        <a
          href="https://onbe-privacy.my.onetrust.com/webform/2210d5ab-d423-4178-86dc-9c670f54317f/56dd8c4c-d316-465e-a658-d73d12fb73ca"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">privacy webform</span>
          </strong>
        </a>
        .
      </p>
      <p>
        <strong>Canada Residents</strong>
      </p>
      <p>
        We adhere to applicable data protection laws in Canada, when relevant
        and appropriate, including the Personal Information Protection and
        Electronics Documents Act(&quot;PIPEDA&quot;).
      </p>
      <p>
        We would like to make sure you are fully aware of all your data
        protection rights. Every user is entitled to the following:
      </p>
      <ul>
        <li>
          The right to be informed - We will inform you of purposes for
          processing your personal information, either orally or in writing.
        </li>
        <li>
          The right to access - You have the right to request from us copies of
          your personal information. If you make a request, we have one month to
          respond to you.
        </li>
        <li>
          The right to correction - You have the right to request that we
          correct any personal information you believe is inaccurate.
        </li>
        <li>
          The right to erasure - You have the right to request that we erase
          your personal information.
        </li>
        <li>
          The right to withdraw consent – You have the right to withdraw consent
          at any time. However, we may retain personal information for the
          period in which it is necessary to fulfill the purpose for which it
          was collected.
        </li>
        <li>
          The right to lodge a complaint - You have the right to file a
          complaint with the Office of the Privacy Commissioner of Canada (OPC)
          if you believe we are in violation of PIPEDA.
        </li>
      </ul>
      <p>
        We will make every effort to honor your request, however in some
        situations, we may not be able to act and/or may impose limitations on
        your request. For instance, if your request is likely to adversely
        affect the rights and freedoms of others, prejudice the execution or
        enforcement of the law, interfere with pending or future litigation, or
        infringe on applicable law.
      </p>
      <p>
        You may exercise these rights free of charge. However, we may charge a
        reasonable fee or refuse to act on a request if it is manifestly
        unfounded or excessive, in particular because of its repetitive
        character.
      </p>
      <p>
        If you would like to exercise any of these rights, please submit a
        request via our{' '}
        <a
          href="https://onbe-privacy.my.onetrust.com/webform/2210d5ab-d423-4178-86dc-9c670f54317f/56dd8c4c-d316-465e-a658-d73d12fb73ca"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">privacy webform</span>
          </strong>
        </a>
        .
      </p>
      <p>
        <strong>When Submitting a Data Subject Rights Request</strong>
      </p>
      <p>
        Data subject rights requests may be submitted via our{' '}
        <a
          href="https://onbe-privacy.my.onetrust.com/webform/2210d5ab-d423-4178-86dc-9c670f54317f/56dd8c4c-d316-465e-a658-d73d12fb73ca"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">privacy webform</span>
          </strong>
        </a>
        . We may request additional information to verify your identity in
        accordance with applicable law.
      </p>
      <h6>WHAT ARE COOKIES?</h6>
      <p>
        Cookies are text files placed on your computer or device to collect
        standard Internet log information and visitor behavior information. When
        you visit our websites, we may collect information from you
        automatically through cookies or similar technology.
      </p>
      <p>
        For further information, visit{' '}
        <a
          href="http://www.allaboutcookies.org/"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">www.allaboutcookies.org</span>
          </strong>
        </a>
        .
      </p>
      <h6>HOW DO WE USE COOKIES?</h6>
      <p>
        We use cookies in a range of ways to improve your experience on our
        website, including:
      </p>
      <ul>
        <li>Identify new or past users.</li>
        <li>Save your password if you are registered on our website.</li>
        <li>Enhance our website and troubleshoot issues.</li>
        <li>
          Investigate, stop, or take action concerning possible or suspected
          illegal activities, fraud, or violations of our terms and conditions.
        </li>
      </ul>
      <h6>WHAT TYPES OF COOKIES DO WE USE?</h6>
      <p>
        There are several different types of cookies our website may use,
        including:
      </p>
      <ul>
        <li>
          Functionality cookies - to enable certain functions of the service and
          to store your preferences, such as language and currency preferences
          and policy acknowledgments.
        </li>
        <li>
          Tracking and performance cookies - to understand service usage and
          performance.
        </li>
        <li>
          Essential cookies - to authenticate users and prevent fraudulent use
          of user accounts.
        </li>
      </ul>
      <p>
        For more information, please read our{' '}
        <a
          href="https://www.onbe.com/policy/cookie-policy"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">Cookie Policy</span>
          </strong>
        </a>
        .
      </p>
      <h6>HOW TO MANAGE YOUR COOKIES</h6>
      <p>
        You can adjust cookies and tracking tools on our website. Your web
        browser may give you the ability to adjust cookies. How you do so
        depends on the type of cookie. Certain web browsers can be set to clear
        past and reject future cookies. If you block cookies on your browser,
        certain features of our website may not work. Additionally, if you limit
        or delete cookies, not all the tracking activities we have defined here
        will stop. The choices you make are both browser and device specific.
        For more information on cookies and how to manage them, visit{' '}
        <a
          href="http://www.allaboutcookies.org/"
          target="_blank"
          rel="noreferrer"
        >
          <strong>
            <span className="terms-link-text">www.allaboutcookies.org</span>
          </strong>
        </a>
        .
      </p>
      <h6>PRIVACY POLICIES OF OTHER WEBSITES</h6>
      <p>
        Our website contains links to other websites. Our Privacy Notice applies
        only to our website and does not apply to the privacy practices of
        third-party websites. If you click on a link to another website, you
        should read the Privacy Notice of that website. We are not liable for
        these third-party practices.
      </p>
      <h6>CHANGES TO OUR PRIVACY POLICY</h6>
      <p>
        We keep our Privacy Notice under regular review and place any updates on
        this web page. We may inform you of any changes to our Privacy Notice as
        required by law. By continuing to use this website and access our
        services you agree to receive updates to our Privacy Notice at this
        website. This Privacy Notice was last updated on August 2, 2023.
      </p>
      <h6>HOW TO CONTACT US</h6>
      <p>
        If you have any questions about our Privacy Notice, the data we hold
        about you, or you would like to exercise one of your data protection
        rights, please do not hesitate to email our Privacy Officer, Thephil
        Russelliah Roby at{' '}
        <a href="mailto:privacy@mypaymentvault.com">
          <strong>
            <span className="terms-link-text">privacy@mypaymentvault.com</span>
          </strong>
        </a>
        . We are committed to resolving any questions you may have.
      </p>
    </div>
  );
};

export default TermsOfUse;
